import React from "react";

import Image from "next/image";

import FigureImageMobile from "public/images/enerflo-solar-project-management-mobile.png";
import FigureImage from "public/images/enerflo-solar-software-platform-project-management.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Project Management";

const imageAlt = "Enerflo Solar Software Platform Project Management.";

const ProjectManagement = () => (
  <div className="bg-gray-100">
    <div className="py-10">
      <div className="bg-navy pt-20 pb-10 transform skew-y-6">
        <HeroSection title={title} className="flex-col-reverse sm:flex-row text-white -skew-y-6">
          <HeroSection.Content className="w-full sm:text-left md:w-1/2 lg:w-5/12 lg:pr-0">
            <HeroSection.Header className="sm:justify-start md:items-start">
              <Heading tag="h2">{title}</Heading>
            </HeroSection.Header>
            <HeroSection.Description className="text-gray-300">
              Integrate with your favorite CRM or use Enerflo’s Project Management tools (AKA Install Tracker) to
              organize your milestones and deal data.
            </HeroSection.Description>
            <HeroSection.Action className="btn-white" href="/features/project-management">
              Manage Like a Boss
            </HeroSection.Action>
          </HeroSection.Content>

          <figure className="w-full md:w-1/2 lg:w-7/12">
            <div className="hidden md:block">
              <Image
                src={FigureImage}
                alt={imageAlt}
                layout="responsive"
                quality={100}
                placeholder="blur"
                className="crispImage"
                sizes="(min-width: 768px) 60vw, 100vw"
                lazyBoundary="400px"
              />
            </div>
            <div className="ml-4 sm:ml-14 md:hidden">
              <Image
                src={FigureImageMobile}
                alt={imageAlt}
                layout="responsive"
                quality={100}
                placeholder="blur"
                className="crispImage"
                lazyBoundary="400px"
              />
            </div>
          </figure>
        </HeroSection>
      </div>
    </div>
  </div>
);

export default ProjectManagement;
